import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "lib/axios";

interface useResourceProps {
  id: string;
  resourceName: string;
  path?: string;
  queryKey?: [];
}

export const useResource = ({
  id,
  resourceName,
  path,
  queryKey,
}: useResourceProps): UseQueryResult<any[]> => {
  const url = `${path ?? resourceName}/${id}`;
  return useQuery({
    queryKey: queryKey ?? [resourceName, id],
    queryFn: async () => {
      const { data } = await axios.get(url);
      return data[resourceName];
    },
  });
};
